import uniqueIdMixin from '@/mixins/unique-id-mixin';
import { mapGetters, mapActions } from 'vuex';
 
export default {
    mixins: [uniqueIdMixin],
    created() {
        this.setEventListeners();
    },
    data() {
        return {
            errorMessageArray: undefined,
            warningMessageArray: undefined,
            currentValue: this.value
        };
    },
    props: {
        /**
         * One or more validators to run on the component's value
         */
        validators: {
            type: [Object, Array],
            default: undefined
        },
        tabindex: {
            type: Number
        },
        iconClassName: {
            type: String
        },
        iconTooltipText: {
            type: String
        },
        autoValidate: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        validationTrigger: {
            immediate: true,
            handler(newVal) {
                if (newVal && this.autoValidate) {
                    this.triggerValidation();
                }
            }
        },
        validationTriggerSuppressMessages: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.triggerValidationSuppressMessages();
                }
            }
        }
    },
    computed: {
        ...mapGetters('validation', [
            'validationTrigger',
            'validationTriggerSuppressMessages'
        ]),
        errorMessages() {
            return this.errorMessageArray || [];
        },
        warningMessages() {
            return this.warningMessageArray || [];
        },
        validatorArray() {
            let vArray = this.validators;
 
            if (vArray && !Array.isArray(vArray)) {
                vArray = [vArray];
            }
 
            return vArray;
        },
        hasError() {
            return this.errorMessages.length > 0;
        },
        hasWarning() {
            return this.warningMessages.length > 0;
        }
    },
    methods: {
        ...mapActions('validation', ['validationAction']),
        setEventListeners() {
            let validateOnInput = false;
 
            if (this.validatorArray && this.validatorArray.length > 0) {
                this.validatorArray.forEach(v => {
                    this.$on(v.validateOn, this.validate);
 
                    if (v.validateOn === 'input') {
                        validateOnInput = true;
                    }
                });
 
                //so we can emit an event when the value becomes valid
                //allows error messages to show on change
                //but allow validation to happen with no visual feedback
                //so you can, for example, enable a button when the value is valid
                if (!validateOnInput) {
                    this.$on('input', this.validateSuppressMessages);
                }
            }
        },
        triggerValidationSuppressMessages() {
            this.validate(this.value, true);
        },
        triggerValidation() {
            this.validate(this.value);
        },
        triggerCurrentValueValidation() {
            this.validate(this.currentValue);
        },
        validateSuppressMessages(value) {
            this.validate(value, true);
        },
        validate(value, suppressMessages) {
            const result = {
                componentUniqueId: this.componentUniqueId,
                valid: true,
                messages: [],
                type: 'error',
                optsValidated: {},
                suppressMessages: suppressMessages
            };
            let messages;
            let type;
            let optsValidated = {};
 
            if (this.validatorArray && this.validatorArray.length > 0) {
                this.validatorArray.forEach(v => {
                    const result = v.validate(value, this.options);
 
                    if (!result.valid) {
                        if (!messages) {
                            messages = [];
                        }
                        type = result.type || 'error';
                        messages.push(...result.messages);
                        optsValidated = { ...result.optsValidated };
                    }
                });
                
                if (messages && messages.length > 0) {
                    if (!suppressMessages) {
                        if (type === 'warning') {
                            this.warningMessageArray = messages;
                            this.errorMessageArray = [];
                        }else{
                            this.errorMessageArray = messages;
                            this.warningMessageArray = [];
                        }
                    }
 
                    result.valid = type !== 'error';
                    result.messages = messages;
                } else {
                    this.errorMessageArray = [];
                    this.warningMessageArray = [];
                }
                if (JSON.stringify(optsValidated) !== '{}') {
                    result.optsValidated = optsValidated;
                }
 
                this.$emit('validate', result, this.refField);
 
                if (this.autoValidate) {
                    this.validationAction(result);
                }
            }
        }
    }
};